<template>
  <div>
    <b-modal
      id="confirmation-modal"
      :visible="show"
      :no-close-on-backdrop="loading"
      :no-close-on-esc="loading"
      @shown="onShown"
      @hidden="hideModal"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ title }}
        </h5>
        <button
          type="button"
          :disabled="loading"
          aria-label="Close"
          class="close"
          @click="hideModal"
        >
          ×
        </button>
      </template>
      <template #modal-footer>
        <b-button
          v-for="additionalButton of additionalButtons"
          :variant="additionalButton.variant"
          class="mr-auto"
          @click="additionalButton.callback(onCancelClick)"
        >
          {{ additionalButton.title }}
        </b-button>

        <b-button
          id="confirmationModalNo"
          variant="light"
          :disabled="loading"
          @click="onCancelClick"
        >
          No
        </b-button>
        <b-button
          id="confirmationModalYes"
          variant="primary"
          :disabled="loading"
          :show-loader="loading"
          @click="onSubmitClick"
        >
          Yes
        </b-button>
      </template>
      {{ message }}
    </b-modal>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {
  ON_CONFIRM_DIALOG_CANCEL_CLICK,
  ON_CONFIRM_DIALOG_OK_CLICK,
  ON_CONFIRM_DIALOG_OPEN,
} from '../../core/services/event-bus';
import eventBus from '../../core/services/event-bus';

const {mapState, mapActions} = createNamespacedHelpers('confirmModal');

export default {
  name: 'ConfirmModal',
  components: {},
  data() {
    return {
      loading: false,
      show: false,
      message: null,
      successMessage: null,
      handler: null,
      handlerParams: null,
      title: null,
      additionalButtons: [],
    };
  },
  methods: {
    onShown() {
      const modal = document.getElementById('confirmation-modal');
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          this.onSubmitClick();
        }
      });
    },
    clearData() {
      this.message = null;
      this.successMessage = null;
      this.handler = null;
      this.handlerParams = null;
      this.title = null;
      this.show = false;
    },
    hideModal() {
      this.clearData();
      eventBus.$emit(ON_CONFIRM_DIALOG_CANCEL_CLICK, true);
    },
    async onCancelClick() {
      this.hideModal();
      eventBus.$emit(ON_CONFIRM_DIALOG_CANCEL_CLICK, true);
    },
    async onSubmitClick() {
      if (this.handler) {
        this.loading = true;
        const response = await this.handler(this.handlerParams);
        this.loading = false;

        if (response.success) {
          // this.$toast('success', this.successMessage);
          eventBus.$emit(ON_CONFIRM_DIALOG_OK_CLICK, true);
          this.clearData();
        } else {
          // if (response.toastError) {
          //   this.$errorDialog(response.toastError);
          // } else {
          //   if (response.body && response.body.non_field_errors) {
          //     this.$errorDialog(response.body.non_field_errors[0]);
          //   }
          // }
          eventBus.$emit(ON_CONFIRM_DIALOG_OK_CLICK, false);
          this.clearData();
        }
      } else {
        this.clearData();
        eventBus.$emit(ON_CONFIRM_DIALOG_OK_CLICK, true);
      }
    },
  },
  beforeMount() {
    eventBus.$on(ON_CONFIRM_DIALOG_OPEN, ({message, successMessage, handler, handlerParams, title, additionalButtons}) => {
      this.message = message;
      this.successMessage = successMessage;
      this.handler = handler;
      this.handlerParams = handlerParams;
      this.title = title;
      this.show = true;
      this.additionalButtons = additionalButtons;
    });
  },
  beforeDestroy() {
    eventBus.$off(ON_CONFIRM_DIALOG_OPEN);
  },
};
</script>

<style lang="scss">
#confirmation-modal___BV_modal_outer_ {
  z-index: 2002 !important;
}
</style>
